import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { store } from '../lib/store/index.ts';
import { rememberedProfileId, useApp } from '../state/app.ts';

/** Restore the active profile after a reload, or send the user back to the picker. */
export function useProfile() {
  const nav = useNavigate();
  const profile = useApp((s) => s.profile);
  const setProfile = useApp((s) => s.setProfile);
  const cachedProfiles = useApp((s) => s.profiles);
  const setProfiles = useApp((s) => s.setProfiles);
  useEffect(() => {
    if (profile) return;
    const id = rememberedProfileId();
    if (!id) {
      void nav({ to: '/' });
      return;
    }
    const cached = cachedProfiles?.find((x) => x.id === id);
    if (cached) {
      setProfile(cached);
      return;
    }
    store
      .listProfiles()
      .then((ps) => {
        setProfiles(ps);
        const p = ps.find((x) => x.id === id);
        if (p) setProfile(p);
        else void nav({ to: '/' });
      })
      .catch(() => void nav({ to: '/' }));
  }, [profile, nav, setProfile, cachedProfiles, setProfiles]);
  return profile;
}
